import React from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { faPaperPlane } from '@fortawesome/pro-light-svg-icons/faPaperPlane';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { ErrorView } from '../../../common/views/ErrorView/ErrorView';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { OutreachShell } from '../components/OutreachShell';
import { useResultsAll } from '../hooks/useResultsAll';
import { outreachBuilderPath } from '../outreachPaths';
import { outreachMessages } from '../outreachMessages';
import { ResultsCompare } from './ResultsCompare';
import { resultsMessages as messages } from './resultsMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
import card from '../live/Campaign.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * Pitch → Results (design outreach-v2 n2, route `/outreach/results`): every song that Plug pitched,
 * side by side. A page under Pitch (navigation v2 d 4e): a back link to Pitch, no Pitch tabs.
 */
const AllSongsResultsScreenComponent: React.FC<{ accountId: number }> = ({ accountId }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { rows, isLoading, error, retry } = useResultsAll(accountId);

  const content = () => {
    if (isLoading) {
      return <LoadingView />;
    }
    if (error !== null || rows === undefined) {
      return <ErrorView error={error ?? undefined} retry={retry} />;
    }
    if (rows.length === 0) {
      return (
        <section className={card.card} data-testid="results-all-empty">
          <p className={`${shared.sub} m-0`}>{intl.formatMessage(messages.allEmpty)}</p>
          <div>
            <SMLButton
              color="primary"
              omitCap
              leftIcon={faPaperPlane}
              // eslint-disable-next-line no-void
              onClick={() => void navigate(outreachBuilderPath())}
            >
              {intl.formatMessage(messages.pitchASong)}
            </SMLButton>
          </div>
        </section>
      );
    }
    return <ResultsCompare rows={rows} />;
  };

  return (
    <OutreachShell
      section="under"
      title={intl.formatMessage(messages.allTitle)}
      subtitle={intl.formatMessage(messages.allIntro)}
      crumbs={[intl.formatMessage(outreachMessages.crumbPitch), intl.formatMessage(messages.allTitle)]}
    >
      {content()}
    </OutreachShell>
  );
};

export const AllSongsResultsScreen = TypedMemo(AllSongsResultsScreenComponent);
